"use client";
import React, { useEffect } from "react";
import { ReduxProvider } from "@/providers/ReduxProvider";
import { AntdRegistry } from "@ant-design/nextjs-registry";
import { ConfigProvider, App as AntdApp } from "antd";
import useInitialDispatch from "@/hook/useInitialDispatch";
import StickyHeaderAndScrollTop from "../Scroll/StickyHeaderAndScrollTop";
import { Hind_Siliguri } from 'next/font/google'

const hindSiliguri = Hind_Siliguri({
  weight: ['300', '400', '500', '600', '700'],
  subsets: ['latin'],
  display: 'swap',
})


function LayoutContent({ children }) {
  useInitialDispatch();
    useEffect(() => {
    const handleContextMenu = (e) => e.preventDefault();
    document.addEventListener("contextmenu", handleContextMenu);

    const handleKeyDown = (e) => {
      if (
        e.keyCode === 123 || 
        (e.ctrlKey && e.shiftKey && (e.keyCode === 73 || e.keyCode === 74)) ||
        (e.ctrlKey && (e.keyCode === 85 || e.keyCode === 83)) 
      ) {
        e.preventDefault();
      }
    };
    document.addEventListener("keydown", handleKeyDown);

    const detectDevTools = setInterval(() => {
      const threshold =
        window.outerWidth - window.innerWidth > 160 ||
        window.outerHeight - window.innerHeight > 160;
      if (threshold) {
        console.warn("⚠️ Developer tools detected!");
      
      }
    }, 1000);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
      clearInterval(detectDevTools);
    };
  }, []);

  return <AntdRegistry>{children}</AntdRegistry>;
}

export default function MainLayout({ children }) {
  return (
    <html lang="en" className={`${hindSiliguri.className} scroll-smooth`}>
      <body>
        <ReduxProvider>
          <LayoutContent>
            {children}
           <StickyHeaderAndScrollTop/> 
          </LayoutContent>
        </ReduxProvider>
      </body>
    </html>
  );
}
